import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/components/Buttons';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useCallback, useEffect, useState } from 'react';
import { useEffectSkipFirst } from '@/utils/hooks';
import { classnames } from '@/utils/html';
import { ButtonPaginationProps } from '.';
import theme from './ButtonPagination.module.scss';

function ButtonPagination<T>({ loader, children, buttonClassName }: ButtonPaginationProps<T>) {
    // const [position, setPosition] = useState<Position<T> | null>(null);
    const [loading, setLoading] = useState(false);
    const [currentData, setCurrentData] = useState<T[] | null>(null);
    const [hasMore, setHasMore] = useState(false);

    const loadMore = useCallback(
        async (reload: boolean) => {
            setLoading(true);
            const value = await loader(currentData, reload);
            setCurrentData(value.data);
            setHasMore(value.hasMore);

            setLoading(false);
        },
        [loader, currentData]
    );

    useEffect(() => {
        if (currentData === null) {
            loadMore(false);
        }
    }, [currentData, loadMore]);

    useEffectSkipFirst(() => {
        loadMore(true);
    }, [loader]);

    const handleClick = useCallback(
        (e) => {
            loadMore(false);
        },
        [loadMore]
    );

    return (
        <div>
            {children(currentData || [])}
            {loading && <LoadingIndicator />}
            {/* {(currentData || []).map((x) => children(x))} */}

            {hasMore && (
                <div>
                    <Button
                        color="tertiary"
                        onClick={handleClick}
                        icon={faChevronDown}
                        loading={loading}
                        size="large"
                        className={classnames(theme.moreButton, buttonClassName)}>
                        <Trans>Show more</Trans>
                    </Button>
                </div>
            )}
        </div>
    );
}

export default ButtonPagination;
